import { render } from "./Pagination.vue?vue&type=template&id=7b47d428&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=7b47d428&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b47d428"],['__file',"webpack-assets/vue/components/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b47d428"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b47d428', __exports__)) {
    api.reload('7b47d428', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=7b47d428&scoped=true", () => {
    api.rerender('7b47d428', render)
  })

}


export default __exports__